export const modifiers = {
    alternateLight: 'alternateLight',
    alternateStrong: 'alternateStrong',
    negativeLight: 'negativeLight',
    negativeStrong: 'negativeStrong',
    positiveLight: 'positiveLight',
    positiveStrong: 'positiveStrong',
};
export const sizes = {
    medium: 'medium',
    small: 'small',
};
